







import Vue from 'vue'
import Component from 'vue-class-component'
import { ICicleChartDataItem } from '@/interfaces'
import { describeArc } from '@/utils/helpers'

@Component({
  name: 'Chart',
  props: {
    title: String,
    data: {
      type: Array,
      default: []
    },
    size: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      default: 'full'
    },
    lineWidth: {
      type: Number,
      default: 8
    },
    startAngle: {
      type: Number,
      default: 0
    }
  }
})
export default class CircleChart extends Vue {
  renderChart () {
    const svg: any = this.$refs.chart
    const data = this.$props.data
    const size = this.$props.size
    svg.setAttribute('width', `${size}px`)
    svg.setAttribute('height', `${size}px`)
    svg.style.width = `${size}px`
    svg.style.height = `${size}px`
    svg.innerHTML = ''
    const lineWidth = this.$props.lineWidth / 100 * size
    let startAngle = this.$props.startAngle || -180 / 2
    const raduis = size / 2 - lineWidth / 2
    const itemsCount = data.filter((item: ICicleChartDataItem) => item.value).length
    const realTotal = data.reduce((acc: number, item: ICicleChartDataItem) => acc + item.value, 0)
    const delta = itemsCount === 1 ? 0.01 : (realTotal / 25)
    const total = itemsCount * delta + realTotal
    const spaceBetweenArcs = (2 * 180) * (delta / total)
    if (realTotal === 0) {
      const path: any = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      const d: string = describeArc(size / 2, size / 2, raduis, 1, 360)
      path.style.opacity = '0.2'
      path.setAttribute('d', d)
      path.setAttribute('fill', 'none')
      path.setAttribute('stroke-linecap', 'round')
      path.setAttribute('stroke-width', lineWidth)
      path.setAttribute('stroke', 'grey')
      svg.appendChild(path)
      if (this.$props.type === 'empty') {
        const path: any = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        const d: string = describeArc(
          size / 2,
          size / 2,
          raduis + 0.1,
          1,
          360
        )
        path.setAttribute('stroke', 'white')
        path.setAttribute('d', d)
        path.setAttribute('fill', 'none')
        path.setAttribute('stroke-linecap', 'round')
        path.setAttribute('stroke-width', lineWidth - 4)
        svg.appendChild(path)
      }
    }
    data.forEach((item: ICicleChartDataItem) => {
      if (item.value === 0) {
        return
      }
      const arcRaduis: number = (2 * 180) * (item.value / total)
      const path: any = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      const d: string = describeArc(size / 2, size / 2, raduis, startAngle, startAngle + arcRaduis)
      path.setAttribute('stroke', item.color)
      path.setAttribute('d', d)
      path.setAttribute('fill', 'none')
      path.setAttribute('stroke-linecap', 'round')
      path.setAttribute('stroke-width', lineWidth)
      svg.appendChild(path)
      if (this.$props.type === 'empty') {
        const path: any = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        const d: string = describeArc(
          size / 2,
          size / 2,
          raduis + 0.1,
          startAngle + spaceBetweenArcs / 10,
          startAngle + arcRaduis - spaceBetweenArcs / 10
        )
        path.setAttribute('stroke', 'white')
        path.setAttribute('d', d)
        path.setAttribute('fill', 'none')
        path.setAttribute('stroke-linecap', 'round')
        path.setAttribute('stroke-width', lineWidth - 4)
        svg.appendChild(path)
      }
      startAngle += arcRaduis + spaceBetweenArcs
    })
  }

  mounted () {
    this.renderChart()
  }
}
